import React from "react";

interface PlaceholderTabProps {
  title: string;
}

export const PlaceholderTab = ({ title }: PlaceholderTabProps) => {
  return (
    <div className="p-12 flex flex-col items-center justify-center h-full text-muted-foreground">
      <p className="text-lg font-medium">{title}</p>
      <p className="text-sm">Content coming soon...</p>
    </div>
  );
};
